// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__6QsxP","colMaxWidth":"Table_colMaxWidth__12E1V"};